import { faHospital, faHospitals, faKitMedical, faUserDoctor, faBuildingUser, faDiceD6 } from '@fortawesome/pro-duotone-svg-icons';

export const deParaTipoServico = (nomeServico: string | undefined) => {
	switch (nomeServico) {
		case 'medicos':
			return '01';
		case 'hospitais':
			return '02'
		case 'laboratorios':
			return '03';
		case 'clinicas':
			return '04';
		case 'outros':
			return '05';
		case 'centrosDiagnostico':
			return '06';
		case 'favoritos':
			return 'TODOS';
		default:
			return '01'
	}
}

export const deParaIDServico = (nomeServico: string | undefined) => {
	switch (nomeServico) {
		case '01':
			return 'medicos';
		case '02':
			return 'hospitais'
		case '03':
			return 'laboratorios';
		case '04':
			return 'clinicas';
		case '05':
			return 'outros';
		case '06':
			return 'centrosDiagnostico';
		default:
			return 'hospitais'
	}
}

export const deParaTitulo = (nomeServico: string | undefined) => {
	switch (nomeServico) {
		case 'medicos':
			return 'Médicos';
		case 'hospitais':
			return 'Hospitais'
		case 'laboratorios':
			return 'Laboratórios';
		case 'clinicas':
			return 'Clínicas';
		case 'outros':
			return 'Profissionais de Saúde';
		case 'centrosDiagnostico':
			return 'Centro de diagnóticos';
		default:
			return 'Favoritos'
	}
}

export const deParaTextoBuscaVazia = (nomeServico: string | undefined) => {
	switch (nomeServico) {
		case 'medicos':
			return 'Nenhum médico localizado.';
		case 'hospitais':
			return 'Nenhum hospital localizado.'
		case 'laboratorios':
			return 'Nenhum laboratório localizado.';
		case 'clinicas':
			return 'Nenhuma clínica localizada.';
		case 'outros':
			return 'Nenhum prestador localizado.';
		case 'centrosDiagnostico':
			return 'Nenhum centro localizado';
		default:
			return 'Você ainda não possui nenhum médico em Favoritos.'
	}
}

export const mostrarDisponibilidade = (nomeServico: string | undefined) => {
	return (
		nomeServico === 'medicos' || 
		nomeServico === 'outros'
	);
}

export const getIcone = (icone: string | undefined) => {
	switch (icone) {
		case 'medicos':
			return faUserDoctor;
		case 'hospitais':
			return faHospital;
		case 'laboratorios':
			return faDiceD6;
		case 'clinicas':
			return faHospitals;
		case 'outros':
			return faKitMedical;
		case 'centrosDiagnostico':
			return faBuildingUser;
		default:
			return faHospital;
	}
}

export const isFavorito = (nomeServico: string | undefined) => {
	return (
		nomeServico === 'favoritos'
	);
}
	